/**
 * Optimizely feature flag for the authenticated MenuRouter switch between the
 * existing MenuPage and the MenuExperiencePage route.
 *
 * Variations:
 * - c: keep authenticated users on the existing MenuPage path
 * - t1: route authenticated users to the new MenuExperiencePage path
 */
export const EXPERIMENT_KEY_MENU_EXPERIENCE_PAGE = 'turnips_ofx_menu_experience_page'
